/* eslint-disable no-unused-vars */

import Vue from 'vue'

export const OrganizationRequestListModule = {
	strict: true, // for developement only
	namespaced: true,
	state: {
		grid: [
			{
				title: 'Organization Requests',
				name: 'organizations',
				statusLookup: 'getIsActive',
				showFilter: true,
				columns: [
					{
						key: "name",
						label: 'ORGANIZATION',
						filter: {
							show: true,
							key: 'name',
							autoComplete: {
								search: 'organization/searchByName',
								label: 'name',
								name: 'name'
							}
						},
						sortable: true,
						widths: "xs24 l8",
                    },
					{
						key: 'isApproved',
						label: "STATUS",
						filter: {
							show: false
						},
						sortable: false,
						widths: "xs24 l8",
						separator: true
                    },
					{
						key: 'createdDate',
						label: "DATE CREATED",
						filter: {
							show: true,
							datepicker: {
								from: 'fromDate',
								to: 'toDate',
							}
						},
						textLookup: 'getIsActiveText',
						sortable: true,
						widths: "xs24 l8",
						separator: true
                    },
                ]
            },
        ],
		data: Array(),
		params: {
			sortOrder: null,
			sortBy: null,
			keywords: null
		}
	},
	mutations: {
		setData: (state, payload = Array()) => state.data = payload,
		setParams: (state, params) => {
			state.params = {
				...state.params,
				...params
			}
		},
		resetParams: state => {
			state.params = {
				isApproved: null
			};

		},
		setPagination: (state, attr) => {
			state.data = {
				...state.data,
				...attr
			}
		},
		removeElement: (state, attribute) => {
			let paramState = {...state.params
			}
			delete paramState[attribute]
			state.params = {...paramState
			}
		}
	},
	getters: {
		getAllData: state => state.data,
		getRecords: state => state.data.data,
		getGrid: state => state.grid,
		getTotals: state => state.data.total,
		getPagination: state => {
			return {
				count: state.data.count,
				page: state.data.page,
				perPage: state.data.perPage
			}
		},
		getParams: state => {
			return state.params
		}
	},
	actions: {
		async load({
			commit,
			rootState
		}, params = Object()) {
			let res = await Vue.prototype.$http.post(rootState.apiUrl + '/organization-registration-list/', params)
			commit('setData', res.data)
		},
		clearParams({
			commit
		}) {
			commit('resetParams')
		},
		updateParams({
			commit
		}, params = Object()) {
			commit('setParams', params)
		},
		clearStatusFilters({
			commit
		}) {
			let params = {
				approvalStatusId: null,
				activeStatusId: null
			}
			commit('setParams', params)
		},
		removePropInParam({
			commit
		}, attr = '') {
			commit('removeElement', attr)
		},
		updatePagination({
			commit
		}, attr) {
			commit('setPagination', attr)
		}
	}
}